import React from 'react';
import { Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    padding: '4px 0 8px',
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: '0.08em',
    color: '#0B9FD9',
    textTransform: 'uppercase',
  },
  sectionTitleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  viewAllLink: {
    fontSize: 12,
    fontWeight: 500,
    color: '#0B9FD9',
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

function SectionHeader({ title, actionLabel, actionHref, external = true }) {
  const classes = useStyles();

  return (
    <div className={classes.sectionHeader}>
      <div className={classes.sectionTitleGroup}>
        <Typography className={clsx(classes.sectionTitle, 'cursor-default')} component="span">
          {title}
        </Typography>
      </div>
      {actionLabel && actionHref && (
        <Link
          href={actionHref}
          {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
          className={classes.viewAllLink}
        >
          {actionLabel}
        </Link>
      )}
    </div>
  );
}

export default SectionHeader;
